import React, { memo, useState } from 'react';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { HelpModal } from './';

const HelpButton = memo(function HelpButton() {
  const [isOpen, setModalVisibility] = useState(false);
  return (
    <>
      <Button onClick={() => setModalVisibility(true)} width="flush">
        {`Help`}
      </Button>
      <HelpModal isOpen={isOpen} onClose={() => setModalVisibility(false)} />
    </>
  );
});

export { HelpButton };
